// extracted by mini-css-extract-plugin
export default {"search":"newsbreak_search__b3Rdh","fieldList":"newsbreak_fieldList__n0o1t","field":"newsbreak_field__eJ85d","count":"newsbreak_count__yQ9F5","list":"newsbreak_list__H03xW"};